export const ENCODED_QUERY_KEY = 'q';
export const STATISTICS_ENCODED_QUERY_KEY = 'qs';
export const CALLS_ENCODED_QUERY_KEY = 'qc';
export const STATUS_STATISTICS_ENCODED_QUERY_KEY = 'qst';
export const QUEUE_ENCODED_QUERY_KEY = 'qq';
export const CAMPAIGNS_ENCODED_QUERY_KEY = 'qcm';
export const SKILL_GROUP_ENCODED_QUERY_KEY = 'qsg';
export const PERIOD_STATUSES_ENCODED_QUERY_KEY = 'qps';
export const TRUNK_STATISTICS_ENCODED_QUERY_KEY = 'qts';
export const LEADS_ENCODED_QUERY_KEY = 'ql';
export const QUALITY_CONTROL_ENCODED_QUERY_KEY = 'qqc';
export const ROLES_ENCODED_QUERY_KEY = 'qr';
export const STATUSES_ENCODED_QUERY_KEY = 'qsl';
export const USERS_ENCODED_QUERY_KEY = 'qu';
export const TRUNKS_ENCODED_QUERY_KEY = 'qtr';
export const AUDIO_CONTROL_ENCODED_QUERY_KEY = 'qac';
export const IVR_CONFIGURATION_ENCODED_QUERY_KEY = 'qiv';
export const AUDIO_ENCODED_QUERY_KEY = 'qa';

const ALL_ENCODED_QUERY_KEYS = [
    ENCODED_QUERY_KEY,
    STATISTICS_ENCODED_QUERY_KEY,
    CALLS_ENCODED_QUERY_KEY,
    STATUS_STATISTICS_ENCODED_QUERY_KEY,
    QUEUE_ENCODED_QUERY_KEY,
    CAMPAIGNS_ENCODED_QUERY_KEY,
    SKILL_GROUP_ENCODED_QUERY_KEY,
    PERIOD_STATUSES_ENCODED_QUERY_KEY,
    TRUNK_STATISTICS_ENCODED_QUERY_KEY,
    LEADS_ENCODED_QUERY_KEY,
    QUALITY_CONTROL_ENCODED_QUERY_KEY,
    ROLES_ENCODED_QUERY_KEY,
    STATUSES_ENCODED_QUERY_KEY,
    USERS_ENCODED_QUERY_KEY,
    TRUNKS_ENCODED_QUERY_KEY,
    AUDIO_CONTROL_ENCODED_QUERY_KEY,
    IVR_CONFIGURATION_ENCODED_QUERY_KEY,
    AUDIO_ENCODED_QUERY_KEY,
];

export function getHashPath(hash: string = window.location.hash): string {
    const value = hash || '';
    const queryIndex = value.indexOf('?');
    return queryIndex === -1 ? value : value.slice(0, queryIndex);
}

export function getHashSearchParams(): URLSearchParams {
    const hash = window.location.hash || '';
    const queryIndex = hash.indexOf('?');
    if (queryIndex === -1) {
        return new URLSearchParams();
    }
    return new URLSearchParams(hash.slice(queryIndex + 1));
}

export function wrapEncodedSearchParams(
    inner: URLSearchParams,
    key: string = ENCODED_QUERY_KEY
): URLSearchParams {
    if (!inner.toString()) {
        return new URLSearchParams();
    }
    const encoded = new URLSearchParams();
    encoded.set(key, encodeBase64Url(inner.toString()));
    return encoded;
}

export function unwrapEncodedSearchParams(
    params: URLSearchParams,
    key: string = ENCODED_QUERY_KEY
): URLSearchParams {
    const encoded = params.get(key);
    if (encoded) {
        const decoded = decodeBase64Url(encoded);
        if (decoded) {
            return new URLSearchParams(decoded);
        }
    }

    const plain = new URLSearchParams();
    params.forEach((value, paramKey) => {
        if (ALL_ENCODED_QUERY_KEYS.indexOf(paramKey) === -1) {
            plain.append(paramKey, value);
        }
    });
    return plain;
}

export function areSearchParamsEqual(left: URLSearchParams, right: URLSearchParams): boolean {
    const leftKeys = collectSearchParamKeys(left).sort();
    const rightKeys = collectSearchParamKeys(right).sort();
    if (leftKeys.join('\0') !== rightKeys.join('\0')) {
        return false;
    }

    const seen: Record<string, boolean> = {};
    for (let i = 0; i < leftKeys.length; i++) {
        const key = leftKeys[i];
        if (seen[key]) continue;
        seen[key] = true;
        const leftValues = left.getAll(key).slice().sort().join('\0');
        const rightValues = right.getAll(key).slice().sort().join('\0');
        if (leftValues !== rightValues) {
            return false;
        }
    }

    return true;
}

function collectSearchParamKeys(params: URLSearchParams): string[] {
    const keys: string[] = [];
    params.forEach((_value, key) => {
        keys.push(key);
    });
    return keys;
}

function encodeBase64Url(value: string): string {
    const utf8 = encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (_match, hex) => {
        return String.fromCharCode(parseInt(hex, 16));
    });
    return btoa(utf8)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/g, '');
}

function decodeBase64Url(value: string): string | null {
    try {
        let base64 = value.replace(/-/g, '+').replace(/_/g, '/');
        const pad = base64.length % 4;
        if (pad) {
            base64 += '===='.slice(0, 4 - pad);
        }
        const binary = atob(base64);
        let percentEncoded = '';
        for (let i = 0; i < binary.length; i++) {
            const hex = binary.charCodeAt(i).toString(16).toUpperCase();
            percentEncoded += '%' + (hex.length === 1 ? '0' + hex : hex);
        }
        return decodeURIComponent(percentEncoded);
    } catch (e) {
        return null;
    }
}
